import { CancelTokenSource } from 'axios'
import { IFilterModel } from 'shared/models/List'

export interface IApprovalResponseModel {
  approvalId: string
  sectionNo: string
  seller: string
  buyer: string
  handoverDate?: Date
  status: ApprovalStatusEnum
  deadline: Date
}

export enum NewOwnersSortFieldEnum {
  SectionNo = 'SectionNo',
  HandoverDate = 'HandoverDate',
  Status = 'Status',
  Deadline = 'Deadline',
}

export type NewOwnerDropdownValueTypes =
  | 'Vis alle'
  | 'Til behandling'
  | 'Godkjent'
  | 'Avvist'

export enum NewOwnersStatusEnum {
  All = 'All',
  ForApproval = 'ForApproval',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
}

export enum ApprovalStatusEnum {
  ForApprovalByBoard = 'ForApprovalByBoard',
  ForApprovalByBbl = 'ForApprovalByBbl',
  NoApproval = 'NoApproval',
  ApprovedByBoard = 'ApprovedByBoard',
  ApprovedByBbl = 'ApprovedByBbl',
  ApprovedAutoByBoard = 'ApprovedAutoByBoard',
  ApprovedAutoByBbl = 'ApprovedAutoByBbl',
  RejectedByBoard = 'RejectedByBoard',
  RejectedByBbl = 'RejectedByBbl',
  Cancelled = 'Cancelled',
}

export interface INewOwnerFilters extends IFilterModel {
  sortColumn: NewOwnersSortFieldEnum
  sortOrder: string
  searchStatus: NewOwnersStatusEnum
  source: CancelTokenSource
  clientId: string
}

export interface PersonModel {
  name: string
  phoneNo: string
  email: string
  birthdate: Date
  isCurrentlyOwner: boolean
}

export enum ApprovalHandler {
  NoOne = 'NoOne',
  Board = 'Board',
  Bbl = 'Bbl',
}
export interface INewOwnerDetailModel {
  approvalId: string
  status: ApprovalStatusEnum
  whoHandlesApproval: ApprovalHandler
  processedDate: Date
  processedBy: string
  comment: string
  sectionNo: string
  ssbNo: string
  buildingName: string
  sellers: PersonModel[]
  buyers: PersonModel[]
  isInvolved: boolean
  handoverDate: Date
  price: string
  deadline: Date
  broker: BrokerModel
}

export interface INewOwnerDetailUpdateModel {
  approvalId: string
  updateModel: ApprovalUpdateModel
}
export interface ApprovalUpdateModel {
  status: ApprovalStatusEnum
  comment?: string
}

export interface BrokerModel {
  association: string
  name: string
  phone: string
}
